var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifeweb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 5.33301H15.3327L14.666 16.6663H5.33268L4.66602 5.33301Z",
    fill: "#4E342E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4038 18.1997C17.3371 18.0663 17.2705 17.9997 17.2038 17.933C15.4778 15.7997 12.6918 15.333 12.6918 15.333H7.30714C7.30714 15.333 4.52114 15.7997 2.79514 17.933C2.72847 17.9997 2.66181 18.0663 2.59514 18.1997C-0.19686 21.2663 0.0031407 26.6663 0.0031407 26.6663H19.9971C19.9971 26.6663 20.1965 21.2663 17.4038 18.1997Z",
    fill: "#0044C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6663 15.3331V13.8665C13.8663 12.9998 14.6663 11.4665 14.6663 9.73315V5.93315C14.6663 1.73315 5.33301 3.19982 5.33301 5.93315V9.73315C5.33301 11.3998 6.13301 12.9331 7.33301 13.7998V15.3331C7.33301 15.3331 7.99967 16.6665 9.99967 16.6665C11.9997 16.6665 12.6663 15.3331 12.6663 15.3331Z",
    fill: "#FCCD88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5328 26.6664C15.3328 26.3998 15.0662 26.1998 14.7995 25.9998L9.46619 22.5331C7.73285 21.3998 5.39952 21.9331 4.26619 23.6664C3.66619 24.5998 4.26619 26.0664 5.19952 26.6664H15.5328Z",
    fill: "#64B5F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 21.9997C2.66602 23.4723 3.86001 24.6663 5.33268 24.6663C6.80535 24.6663 7.99935 23.4723 7.99935 21.9997C7.99935 20.527 6.80535 19.333 5.33268 19.333C3.86001 19.333 2.66602 20.527 2.66602 21.9997Z",
    fill: "#FAD695"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66666 -0.000244141C5.93333 0.0664225 2 2.46642 2 13.3331L5.33333 15.9997V8.66642L12 4.66642L14.6667 7.33309V15.9997L18 13.3331C18 11.1331 18.2 1.33309 12 1.33309L11.3333 -0.000244141H9.66666Z",
    fill: "#795548"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 9.33317C11.333 8.93317 11.5997 8.6665 11.9997 8.6665C12.3997 8.6665 12.6663 8.93317 12.6663 9.33317C12.6663 9.73317 12.3997 9.99984 11.9997 9.99984C11.5997 9.99984 11.333 9.73317 11.333 9.33317ZM7.33301 9.33317C7.33301 9.73317 7.59967 9.99984 7.99967 9.99984C8.39967 9.99984 8.66634 9.73317 8.66634 9.33317C8.66634 8.93317 8.39967 8.6665 7.99967 8.6665C7.59967 8.6665 7.33301 8.93317 7.33301 9.33317Z",
    fill: "#784719"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 15.3331V13.7998C8.06634 14.3331 8.99967 14.6665 10.0663 14.6665C11.0663 14.6665 11.933 14.3331 12.6663 13.8665V15.3331C12.6663 15.3331 11.9997 17.3331 9.99967 17.3331C7.99967 17.3331 7.33301 15.3331 7.33301 15.3331Z",
    fill: "#FCC068"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifeweb);
export default __webpack_public_path__ + "static/media/wifeweb.7027b05ea76b7780c193d325c1335015.svg";
export { ForwardRef as ReactComponent };